import createLucideIcon from '../createLucideIcon';

const StopCircle = createLucideIcon('StopCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['rect', { x: '9', y: '9', width: '6', height: '6', key: 'o3kz5p' }],
]);

export default StopCircle;
